import React, { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { getReadingTimeMinutes } from '../../Thumb/helpers';
const ReadingTime = ({ deviation })=>{
    const readingTime = useMemo(()=>getReadingTimeMinutes(deviation.textContent), [
        deviation.textContent
    ]);
    /* prettier-ignore */ return /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "deviationview.journal.readingTime",
        count: readingTime
    }, {
        readingTime
    }, " min");
};
ReadingTime.displayName = 'ReadingTime';
export default ReadingTime;
